import { db } from '../firebase';
import { collection, getDocs, getDoc, doc, query, orderBy } from 'firebase/firestore';

export const getAboutContent = async () => {
  const snap = await getDoc(doc(db, 'about_content', 'main'));
  return snap.exists() ? snap.data().Paragraph : '';
};

export const getMissionVision = async () => {
  const snap = await getDocs(collection(db, 'about_mission_vision'));
  const map = {};
  snap.docs.forEach(d => { map[d.data().Title] = d.data().Description; });
  return { mission: map['Mission'] || '', vision: map['Vision'] || '' };
};

export const getMilestones = async () => {
  const q = query(collection(db, 'milestones'), orderBy('order', 'asc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => d.data());
};

export const getFounder = async () => {
  const snap = await getDoc(doc(db, 'founder', 'content'));
  return snap.exists() ? snap.data() : null;
};
